import adminApi from "../../api/admin";

const state = () => ({
  users: [],
  loading: false,
  error: null,
});

const mutations = {
  setUsers(state, users) {
    state.users = users;
  },
  setLoading(state, v) {
    state.loading = v;
  },
  setError(state, err) {
    state.error = err;
  },
};

const actions = {
  async loadUsers({ commit }) {
    commit("setLoading", true);
    commit("setError", null);
    try {
      const users = await adminApi.getUsers();
      commit("setUsers", users || []);
    } catch (e) {
      commit("setError", e.message || "Failed to load users");
      commit("setUsers", []);
    } finally {
      commit("setLoading", false);
    }
  },
  async setAdminRole({ commit, dispatch }, { uid, admin: makeAdmin }) {
    commit("setError", null);
    await adminApi.setUserAdmin(uid, makeAdmin);
    await dispatch("loadUsers");
  },
  async createUser({ dispatch }, payload) {
    await adminApi.createUser(payload);
    await dispatch("loadUsers");
  },
  async deleteUser({ dispatch }, targetUid) {
    await adminApi.deleteUser(targetUid);
    await dispatch("loadUsers");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
